<template>
  <md-content class="navi-desktop">
    <md-list>
      <template v-for="item in menu">
        <md-list-item
          v-if="item.submenu"
          :key="item.name"
          :to="item.to"
          md-expand
          :md-expanded="true"
        >
          <md-icon :md-src="require('../assets/' + item.src)" />
          <span class="md-list-item-text">{{$t(item.name)}}</span>
          <md-list slot="md-expand">
            <md-list-item
              v-for="i in item.submenu"
              :key="i.name"
              class="md-inset"
              :to="item.to + i.to"
            >{{$t(i.name)}}</md-list-item>
          </md-list>
        </md-list-item>

        <md-list-item v-else :key="item.name" :to="item.to">
          <md-icon :md-src="require('../assets/' + item.src)" />
          <span class="md-list-item-text">{{$t(item.name)}}</span>
        </md-list-item>
      </template>
    </md-list>
  </md-content>
</template>

<script>
import menu from "../menu.js";
export default {
  name: "Navi",
  data() {
    return {
      menu: menu
    };
  }
};
</script>

<style lang="scss">
@import "~vue-material/src/components/MdLayout/mixins";

.navi-desktop {
  @include md-layout-xsmall {
    display: none;
  }
  width: 256px;
  display: flex;
  position: fixed;
  top: 0;
  bottom: 0;

  padding: 64px 0px 0px 0px;
  @include md-layout-small {
    padding: 48px 0px 0px 0px;
  }
  .md-list-item {
    width: 256px;
  }
  overflow-x: hidden;
  overflow-y: auto;
}
</style>